import React from 'react'

import DropdownItem from './DropdownItem'

import {
    DropdownMenuDiv
} from '../../Styles/Components/DropdownMenuStyles'

function DropdownMenu(props) {
    var items = props.items

    return (
        <DropdownMenuDiv>
            {items.map(item => (
                <DropdownItem item={item} key={item.item_name} />
            ))}
        </DropdownMenuDiv>
    )
}

export default DropdownMenu